import SubmitContext from 'context/submit/submitContext'
import PageContext from 'context/page/pageContext'
import CannedFishProduct from 'models/CannedFishProduct'
import React, { useContext, useEffect, useState } from 'react'
import Select from 'react-select'
import { Col, Row, Alert } from 'reactstrap'
import { useFormUtils } from 'views/shared/useFormUtils'
import {
  fishTypeOptions,
  packagingInitialState,
  packedInOptionsDefault,
  tunaPackedInOptions,
  mackerelPackedInOptions,
  salmonPackedInOptions,
  sardinesPackedInOptions,
} from './constants'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'

const CannedFishPackage = () => {
  const submitContext = useContext(SubmitContext)
  const pageContext = useContext(PageContext)

  const { current, setCurrent, updating } = submitContext
  const { setScrollToTop } = pageContext

  const [packaging, setPackaging] = useState(packagingInitialState)

  const [packedInOptions, setPackedInOptions] = useState(packedInOptionsDefault)

  const { setSelect, asterisk } = useFormUtils()

  const methods = useFormContext()

  const setPackedInType = () => {
    console.log('current.FishType is: ' + current.FishType)
    console.log('current.FishType is: ' + current.FishType)
    if (current.FishType === 'Chunk, Light Tuna - 5 oz.') {
      setPackedInOptions(tunaPackedInOptions)
    } else if (current.FishType === 'Mackerel - 15 oz.') {
      setPackedInOptions(mackerelPackedInOptions)
    } else if (
      current.FishType === 'Pink Salmon - 5 oz.' ||
      current.FishType === 'Pink Salmon - 6 oz.' ||
      current.FishType === 'Pink Salmon - 14.75 oz.'
    ) {
      setPackedInOptions(salmonPackedInOptions)
    } else if (current.FishType === 'Sardines - 15 oz.') {
      setPackedInOptions(sardinesPackedInOptions)
    } else if (current.FishType === 'Chunk, Light Tuna - 5 oz.') {
      setPackedInOptions(tunaPackedInOptions)
    } else if (current.FishType === 'Mackerel - 15 oz.') {
      setPackedInOptions(mackerelPackedInOptions)
    } else if (
      current.FishType === 'Pink Salmon - 5 oz.' ||
      current.FishType === 'Pink Salmon - 6 oz.' ||
      current.FishType === 'Pink Salmon - 14.75 oz.'
    ) {
      setPackedInOptions(salmonPackedInOptions)
    } else if (current.FishType === 'Sardines - 15 oz.') {
      setPackedInOptions(sardinesPackedInOptions)
    }
  }

  const packedInReset = () => {
    methods.reset(
      { PackedIn: '' },
      {
        errors: false, // errors will not be reset
        dirtyFields: false, // dirtyFields will not be reset
        dirty: false, // dirty will not be reset
        isSubmitted: false,
        touched: false,
        isValid: false,
        submitCount: false,
      }
    )
  }

  useEffect(() => {
    setScrollToTop(true)
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (current?.category === packagingInitialState.category) {
      const { category, subCategory, FishType, PackedIn } = current
      setPackaging({
        category,
        subCategory,
        FishType: {
          value: FishType || '',
          label: FishType.length > 0 ? FishType : 'Fish Type',
        },
        PackedIn: {
          value: PackedIn || '',
          label: PackedIn.length > 0 ? PackedIn : 'Packed in',
        },
      })
      setPackedInType()
    } else if (!updating) {
      setCurrent(CannedFishProduct)
    }
    console.log(current)
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current])

  useEffect(() => {
    if (current?.fkCategory === packagingInitialState.category) {
      setPackedInType()
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current])

  return (
    <Row>
      <Col xs={6}>
        <p>
          <strong>Fish Type {asterisk}</strong>
        </p>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          options={fishTypeOptions}
          name="FishType"
          value={packaging.FishType}
          control={methods.control}
          rules={{ required: true }}
          placeholder={'Select Fish Type'}
          onChange={([selected]) => {
            packedInReset()
            console.log('selected is: ' + JSON.stringify(selected))
            setSelect(selected, 'FishType')
            return selected
          }}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="FishType"
            message={'⚠ This selection is required.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
        <br />
        <p>
          <strong>
            Packed in {current?.FishType !== '' ? asterisk : null}
          </strong>
        </p>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          options={packedInOptions}
          name="PackedIn"
          value={packaging.PackedIn}
          control={methods.control}
          rules={{ required: true }}
          placeholder={'Select Packed In'}
          isDisabled={current?.FishType === ''}
          onChange={([selected]) => {
            setSelect(selected, 'PackedIn')
            return selected
          }}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="PackedIn"
            message={'⚠ This selection is required.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
        <br />
      </Col>
    </Row>
  )
}

export default CannedFishPackage
